import React from "react"
import styled, { css } from "styled-components"

import DetailedBoardHeaders from "../../../components/DetailedBoardHeaders"
import DetailedBoardRow from "../../../components/DetailedBoardRow"
import { getNumberOfPages, sortPlayersByChapterRanks } from "../../../utils"

import { useStore } from '../../../zustandStore'
import { shallow } from 'zustand/shallow'

import { MIDLINE_ELLIPSIS } from "../../../unicodeChars"

const ChapterBoardPreview = ({
  pageSize = 10,
  previewSize = 6,
  currentChapterName,
  currentPage,
  includeTotal = false,
  className,
  showChapterRank = true,
  heightPx
}) => {
  const players = useStore(state => state.players)
  const numberOfPages = getNumberOfPages(players, pageSize)

  const sortedPlayers = sortPlayersByChapterRanks(players, currentChapterName)

  const playersOffset = pageSize * (currentPage - 1)

  const thisPageEnd = Math.min((pageSize * currentPage), players.length)
  const thisPageSize = thisPageEnd - playersOffset

  const fullPageLastPlayerIndex = thisPageEnd - 1

  const showEllipsisRow = thisPageSize > previewSize
  const displayedPlayers = sortedPlayers.slice(playersOffset, playersOffset + previewSize - (showEllipsisRow ? 2 : 0))

  console.log({ currentPage, playersOffset, displayedPlayers: displayedPlayers.length, fullPageLastPlayerIndex })
  return (
    // <SpacingWrapper >


      <TableWrapper heightPx={heightPx} className={className}>
        {/* <DetailedBoardHeaders
          key='header'
          className='header-row'
          chapterNames={currentChapterName ? [currentChapterName] : []}
          includeTotal={includeTotal}
        >Page {currentPage}</DetailedBoardHeaders> */}
        <div className='header-row'>
          <span className='all-caps'>{currentChapterName}</span>
          &nbsp;({currentPage} of {numberOfPages})
        </div>
        {displayedPlayers.map((player, i) =>
          <DetailedBoardRow
            className={'row '+ (i % 2 === 0 ? 'row-even' : 'row-odd')}
            key={player.slug}
            chapterNames={currentChapterName ? [currentChapterName] : []}
            includeRankForChapters={currentChapterName && showChapterRank ? [currentChapterName] : []}
            player={player}
            includeTotal={includeTotal}
          />
        )}

        {showEllipsisRow && (<>
          <DetailedBoardRow
            className={'row ellipsis-row '+ (displayedPlayers.length % 2 === 0 ? 'row-even' : 'row-odd')}
            isPlaceholder
          >
            {MIDLINE_ELLIPSIS}
          </DetailedBoardRow>
          <DetailedBoardRow
            className={'row '+ ((displayedPlayers.length + 1) % 2 === 0 ? 'row-even' : 'row-odd')}
            key={sortedPlayers[fullPageLastPlayerIndex].slug}
            chapterNames={currentChapterName ? [currentChapterName] : []}
            includeRankForChapters={currentChapterName && showChapterRank ? [currentChapterName] : []}
            player={sortedPlayers[fullPageLastPlayerIndex]}
            includeTotal={includeTotal}
          />
        </>)}
      </TableWrapper>
  )
}

export default ChapterBoardPreview

const SpacingWrapper = styled.div`
  ${'' /* margin: 20px 0 20px 0; */}
  ${'' /* min-width: 400px; */}
  display: flex;
  justify-content: center;
`

const TableWrapper = styled.div`
  --time-column-width: 90px;
  --player-column-width: 120px;
  display: flex;
  flex-direction: column;
  ${'' /* max-width: 300px; */}
  border-top: 2px solid #aaa;
  ${'' /* border-radius: 3px; */}
  flex-shrink: 1;

  min-height: ${props => props.heightPx}px;
  max-height: ${props => props.heightPx}px;
  * {
    font-size: 1em;
  }
  .column {
    width: var(--time-column-width);
    min-width: var(--time-column-width);
    max-width: var(--time-column-width);
    flex-grow: 1;
  }
  .column-player {
    width: var(--player-column-width);
    min-width: var(--player-column-width);
    max-width: var(--player-column-width);
    flex-grow: 2;
    .rank {
      margin-left: 2px;
      font-size: 0.87em;
      line-height: 1em;
      margin: 0;
      padding: 0 3px;
    }
  }
  .row, .header-row {
    width: 100%;
    &:not(.ellipsis-row) { flex-grow: 1; }
    flex-shrink: 1;
  }
  .header-row, .header-row > * {
    line-height: 1.4em;
    padding: 0;
    margin: 0;
  }

  .header-row {
    border-bottom: 1px solid #aaa;
    font-size: 2.1em;
    display: flex;
    align-items: center;
    justify-content: center
  }

  .row {
    font-size: 1.1em;
  }

  .row-even, .row-even:hover {
    background-color: var(--every-other-row-color)!important;
  }

  .flag {
    margin-right: auto;
  }

  .row:last-child {
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
  }
  .ellipsis-row {
    flex-shrink: 10;
  }

  .chapter-rank {
    font-size: 0.87em;
  }
  .all-caps {
    text-transform: uppercase;
  }
`
